export class CurrentUser{
    username: string='';
    id: number=0;
    fullname: string='';
    company:string='';
    imageversion: number = 0;
    imagetype: string = '';
    requiresscreenreader: boolean = false;
    skipaifacematching: boolean = false;
    skipaivideofeedcheck: boolean = false;
    unlockpassportphoto: boolean = false;
}